import { SellerApiMoySklad as SellerApiMoySkladComponent } from 'components/sellers/SellerApiMoySklad/SellerApiMoySklad'
import { useParams } from 'react-router-dom'

export const SellerApiMoySklad: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerApiMoySkladComponent type='seller' sellerId={id as string} />
}
